import React from "react";
import { connect } from "react-redux";
import Fade from "@mui/material/Fade";
import { getPhotoSizeSetting, getPhotoTagSetting, photoTagHoverSettings } from "components/Photos/PhotoTool/Shared";
import { UserPreference } from "interfaces/Mueller.Business.Models";
import { Chip } from "@mui/material";

interface PhotoTagsProps {
  photoTagsArray: string[],
  photoWidth: number,
  photoHeight: number,
  horizontal: boolean,
  addSelectedPhotoTag: (photoTag: string) => any,
  //Redux State
  preferences: UserPreference[],
  //Redux Actions
}

const PhotoTags = (props: PhotoTagsProps) => {

  const photoSizeSetting = getPhotoSizeSetting(props.preferences);
  const maxTags = photoSizeSetting.maxPhotoTags;
  const hoverSetting = getPhotoTagSetting(props.preferences);

  if (
    (!props.horizontal && !photoSizeSetting.showsPhotoTags) // Extra small photos don't get any photo tags, don't display if that is the current setting unless we're displaying horizontal (full size photo)
    || (!props.horizontal && hoverSetting === photoTagHoverSettings.HIDE) // If settings are set to hide tags, don't display unless we're displaying horizontal (full size photo)
    || (!props.photoTagsArray || props.photoTagsArray.length === 0) // No tags or the array is empty
  ) {
    return null;
  }

  const mapHoverSettingToClassName = (hoverSetting: string) => hoverSetting === photoTagHoverSettings.SHOW ? " always-show" : "";

  return props.horizontal ? (
    <Fade in>
      <div className={"photo-tags photo-tags-horizontal"}>
        {props.photoTagsArray.map((tag, index) => (
          <Chip
            className={`photo-chip photo-tag-chip always-show`}
            key={index}
            label={tag}
          />
        ))}
      </div>
    </Fade>
  ) : (
      <div className="photo-tags photo-tags-wrapper">
        {props.photoTagsArray.map((tag, index) => {

          // We're past the max, don't return anything
          if (index + 1 > maxTags) return null;

          // Can just return a chip normally if we're still under the max tags
          if (index + 1 < maxTags) {
            return (
              <Chip
                className={`photo-chip photo-tag-chip${mapHoverSettingToClassName(hoverSetting)}`}
                key={index}
                label={tag}
                onClick={() => props.addSelectedPhotoTag(tag)}
              />
            );
          }

          // If we're at the max tags, we need to decide if we're rendering a normal chip or a default chip showing how many are not showing
          if (index + 1 === maxTags) {
            if (props.photoTagsArray.length > maxTags) { //There are more tags than the max, show the last chip that tells them how many more there are
              return (
                <Chip
                  className={`photo-chip photo-tag-chip${mapHoverSettingToClassName(hoverSetting)}`}
                  key="the-last-chip"
                  label={`+${props.photoTagsArray.length - maxTags + 1} more`}
                />
              );
            }
            else { // We're at the max but this is the last tag so we display it anyways
              return (
                <Chip
                  className={`photo-chip photo-tag-chip${mapHoverSettingToClassName(hoverSetting)}`}
                  key={index}
                  label={tag}
                  onClick={() => props.addSelectedPhotoTag(tag)}
                />
              );
            }
          }
        })}
      </div>
  );
};

const mapStateToProps = state => ({
  preferences: state.preferences
});

export default connect(
  mapStateToProps,
  null
)(PhotoTags);
